/* design—light · sort pill bar + sticky collection toolbar.
   Pills injected INTO the toolbar's .sticky-element (one bar: Filtr + count + pills);
   the bar sticks below the smart-sticky header via --dl-sticky (published by
   sections/dl-header-b.liquid since 2026-10-04; this file used to keep its own copy).
   Uses native ?sort_by= URLs so all active filters are kept.
   Order per Hynek: price asc, price desc, A–Z, Z–A, then the rest. */
(function () {
  'use strict';
  if (window.__dlSortBar) return;
  window.__dlSortBar = true;

  var OPTS = [
    ['price-ascending', 'Cena: nejnižší'],
    ['price-descending', 'Cena: nejvyšší'],
    ['title-ascending', 'A–Z'],
    ['title-descending', 'Z–A'],
    ['best-selling', 'Nejprodávanější'],
    ['created-descending', 'Nejnovější']
  ];

  var SELECT_ORDER = [
    'price-ascending', 'price-descending',
    'title-ascending', 'title-descending',
    'best-selling', 'created-descending', 'created-ascending',
    'manual', 'relevance'
  ];

  function currentSort() {
    try { return new URLSearchParams(location.search).get('sort_by') || ''; }
    catch (e) { return ''; }
  }

  function hrefFor(val, isActive) {
    var p;
    try { p = new URLSearchParams(location.search); } catch (e) { return location.pathname + '?sort_by=' + val; }
    if (isActive) p.delete('sort_by'); else p.set('sort_by', val);
    p.delete('page');
    var q = p.toString();
    return location.pathname + (q ? '?' + q : '');
  }

  function reorderSelects() {
    var sels = document.querySelectorAll('select[name="sort_by"], select[data-sort-by], #SortByContainer select');
    Array.prototype.forEach.call(sels, function (sel) {
      if (sel.__dlOrdered) return;
      var val = sel.value;
      var opts = Array.prototype.slice.call(sel.options);
      opts.sort(function (a, b) {
        var ia = SELECT_ORDER.indexOf(a.value), ib = SELECT_ORDER.indexOf(b.value);
        if (ia === -1) ia = SELECT_ORDER.length + opts.indexOf(a);
        if (ib === -1) ib = SELECT_ORDER.length + opts.indexOf(b);
        return ia - ib;
      });
      opts.forEach(function (o) { sel.appendChild(o); });
      sel.value = val;
      sel.__dlOrdered = true;
    });
  }

  function build() {
    var wrapper = document.getElementById('ProductGridWrapper');
    var grid = document.getElementById('ProductGridContainer');
    if (!wrapper || !grid || document.getElementById('dl-sortbar')) return;
    var cur = currentSort();
    var bar = document.createElement('nav');
    bar.id = 'dl-sortbar';
    bar.className = 'dl-sortbar';
    bar.setAttribute('aria-label', 'Řazení produktů');
    var lab = document.createElement('span');
    lab.className = 'dl-sortbar__label';
    lab.textContent = 'Seřadit:';
    bar.appendChild(lab);
    OPTS.forEach(function (o) {
      var active = cur === o[0];
      var a = document.createElement('a');
      a.className = 'dl-sortbar__pill' + (active ? ' is-active' : '');
      a.textContent = o[1];
      a.href = hrefFor(o[0], active);
      a.title = active ? 'Zrušit řazení' : o[1];
      if (active) a.setAttribute('aria-current', 'true');
      bar.appendChild(a);
    });
    var stick = wrapper.querySelector(':scope > .sticky-element');
    if (stick) stick.appendChild(bar);
    else wrapper.insertBefore(bar, grid);
  }

  function refresh() {
    var b = document.getElementById('dl-sortbar');
    if (b && b.parentNode) b.parentNode.removeChild(b);
    build();
    reorderSelects();
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    build();
    reorderSelects();
    document.addEventListener('collection:rerendered', refresh);
    window.addEventListener('popstate', refresh);
    if (window.MutationObserver) {
      var w = document.getElementById('ProductGridWrapper');
      if (w) {
        new MutationObserver(function () {
          if (!document.getElementById('dl-sortbar')) build();
          reorderSelects();
        }).observe(w, { childList: true, subtree: true });
      }
    }
  });
})();
